import 'regenerator-runtime/runtime'
import ky from 'ky-universal';
import localforage from 'localforage';
import _ from 'lodash';

/*
login
loginExternal

//Create a new user
signup
signupExternal
confirm --confirms the email/sms verification token

//Recover the user
requestPasswordRecovery
recover --confirms the email recovery token

verify --processes both confirm and recover

//Get current user/details/token
currentUser
getToken
getBalance

//
openCashierExternal --opens global iframe
openCashier --returns url for an iframe
*/

export default class Auth {

    constructor() {
        this.name = "GENERIC"
        /*this.api = ky.create({
            prefixUrl: 'https://dev.bet777.be/api/'
        });*/

        this.api = ky.extend({
            prefixUrl: 'https://api-dev.bet777.be/api/',

        });
        
        window.api = this.api
        this.store = localforage.createInstance({
            driver: localforage.LOCALSTORAGE,
            name: 'sportify',
            version: 1.0,
            storeName: 'auth',
            description: 'sportify auth'
        });
    }

    async getStoreItem(key) {
        let value = null;
        try {
            value = await this.store.getItem(key);
            console.log(value);
        } catch (err) {
            console.log(err);
        }

        return value

    }

    async login(username, password, params = {}) {
        
        params['username'] = username;
        params['password'] = password;
        params['platform'] = "web";
        params['device_name'] = navigator.userAgent;
        
        let result = {};
        try {
            //await api.post("clearToken", {json: params}).json()

            let response = await api.post("login", {json: params}).json()

            let auth = this._formatUser(_.get(response, 'user'))
            this.store.setItem("frontend_token", _.get(response, 'frontend_token'));
            this.store.setItem("access_token", _.get(response, 'access_token'));
            result['status'] = true;
            result['data'] = auth;
            result['extra'] = {}; //redirects or whatever

        } catch(e) {
            result['status'] = false;
            result['error_code'] = "INVALID_LOGIN";
            result['error_message'] = true;
        }

        return result
    }

    loginExternal() {
        //global frame
        
    }

    async signup(email, password, params = {}) {
        let response = await this.api.post("post");
        this.store.setItem("auth", { email: email, password: password, params: params });

        let result = {};
        result['status'] = true;
        result['error_code'] = "INVALID_EMAIL";
        result['error_message'] = "Reason user cannot be registered";
        return result
    }

    async signupExternal() {
        //opens global iframe
    }

    //this confirms the registration token is ok
    async confirm(token, remember) {
        return await this.verify('signup', token, remember);
    }

    async requestPasswordRecovery(email) {
        let response = await this.api.post("recover", {email: email});

        let result = {};
        result['status'] = true;
        result['error_code'] = "INVALID_EMAIL";
        result['error_message'] = "No user found";
        return result
    }

    //used to recover the user account from a token
    async recover(token) {
        return await this.verify('recovery', token);
    }

    async verify(type, token) {
        let response = await this.api.post("recover", {type: type, token: token});

        let result = {};
        result['status'] = true;
        result['error_code'] = "VERIFY_EMAIL";
        result['error_message'] = "No user found";
        return result
    }
    
    _formatUser(response) {
        let auth = {
            id: _.get(response, 'id'),
            username: _.get(response, 'Account'),
            email: _.get(response, 'Email'),
            currency: _.get(response, 'currency', 'EUR'),
            balance: _.get(response, 'Money'),
            created_at: _.get(response, 'lastAction'),
            updated_at: _.get(response, 'lastAction'),
        }
        this.store.setItem("auth", auth);
        this.store.setItem("sportsbook_token", _.get(response, 'token'));
        return auth;
    }

    async currentUser(force = false) {
        if(force) {
            let frontend_token = await this.getStoreItem('frontend_token');
            let response = await this.api.get("user",  {headers: { 'Authorization': 'Bearer ' +  frontend_token}}).json();
            return this._formatUser(response);
        }
        return await this.getStoreItem("auth");
    }

    async getToken(force = false) {
        if(force) {
            let response = await this.api.post("refresh");
        }
        return "jwt";
    }
    
    async getBalance(force = true) {
        if(force) {
            let response = await this.api.post("refresh");
            return {status: true, amount: 0, currency: 'GBP'};
        }
        return {status: true, amount: 0, currency: 'GBP'};
    }
    
    async openCashierExternal() {
        //call the global iframe
        return true
    }

    async openCashier() {
        //url to iframe/popup
        return {status: true, url: "something"};
    }

}